import styled from "@rentiohq/web-theme";
import { PillBase } from "scenes/Properties/components/pill.styles";

// RentMatch wordmark brand hue — a brand asset, intentionally not a theme
// token (mirrors RM_COLORS.brand in the RentMatch scene).
export const RENTMATCH_BRAND_COLOR = "#FF3A59";

/**
 * Neutral, with the state carried by the icon alone.
 *
 * The pill used to be pink in both states, which read as a warning whether
 * the property was published or not: the color said "look at this" and the
 * small glyph said what had actually happened (Jonas, 2026-10-06). Grey and
 * dark text say "this is a fact about the property"; the green check or the
 * red sign says which fact.
 */
export const RentMatchPill = styled.button.attrs({ type: "button" })`
  ${PillBase}
  /* One step up the neutral scale, with the border one step above that so it
     still reads against the fill: neutral30 would have all but disappeared
     on neutral20 (Jonas, 2026-10-06). */
  border: 1px solid ${({ theme }) => theme.colors.neutral40};
  font-size: 12px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${({ theme }) => theme.colors.neutral80};
  background-color: ${({ theme }) => theme.colors.neutral20};
`;

/**
 * The glyphs inside the pill, which color themselves through `currentColor`
 * so the color is a theme token here rather than an attribute on a path.
 */
export const PublishedGlyph = styled.svg`
  color: ${({ theme }) => theme.colors.green60};
  display: block;

  .disc {
    fill: ${({ theme }) => theme.colors.neutral0};
  }
`;

export const UnpublishedGlyph = styled.svg`
  color: ${RENTMATCH_BRAND_COLOR};
  display: block;

  .disc {
    fill: ${({ theme }) => theme.colors.neutral0};
  }
`;

// No bedroom glyph exists in @rentiohq/web-assets, so render a small inline
// bed icon. Drawn as a thin outline (stroke, no fill) to match the streamline
// style of the other meta icons; inherits the surrounding text color.
export const BedIcon = styled.svg`
  width: 16px;
  height: 16px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
